import React from 'react';
import {
  AiOutlineShoppingCart,
  AiOutlineArrowRight,
} from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import './HeroSections.css';

const HeroSection1 = () => {
  const navigate = useNavigate();

  return (
    <div className="row hero-section-1">
      <div className="hero-1-background">
        <div className="hero-1-circle hero-1-circle-1"></div>
        <div className="hero-1-circle hero-1-circle-2"></div>
        <div className="hero-1-circle hero-1-circle-3"></div>
      </div>

      <div className="col col-24 lg-12 hero-1-content">
        <div className="hero-1-badge">
          <span className="hero-1-badge-dot"></span>
          New Projects Added Weekly
        </div>

        <h1 className="hero-1-title" data-aos="fade-up">
          ONE STOP SOLUTION
        </h1>

        <h1
          className="hero-1-subtitle"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Free and Best Software Projects
        </h1>

        <span
          className="hero-1-description"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Whether you're preparing for a college submission, exploring
          tutorials, or looking for real-world code samples,{' '}
          <strong>ProjectKart</strong> gives you instant access to high-quality
          projects with complete documentation.
        </span>

        <div className="hero-1-buttons" data-aos="fade-up" data-aos-delay="300">
          <button
            type="button"
            className="btn btn-primary btn-lg hero-1-btn-primary"
            onClick={() => navigate('/products')}
          >
            <AiOutlineShoppingCart /> Explore Projects
          </button>
          <button
            type="button"
            className="btn btn-lg hero-1-btn-secondary"
            onClick={() => navigate('/contact')}
          >
            <AiOutlineArrowRight /> Contact Us
          </button>
        </div>

        <div className="hero-1-stats" data-aos="fade-up" data-aos-delay="400">
          <div className="hero-1-stat">
            <span className="hero-1-stat-number">500+</span>
            <span className="hero-1-stat-label">Projects</span>
          </div>
          <div className="hero-1-stat">
            <span className="hero-1-stat-number">10K+</span>
            <span className="hero-1-stat-label">Happy Users</span>
          </div>
          <div className="hero-1-stat">
            <span className="hero-1-stat-number">24/7</span>
            <span className="hero-1-stat-label">Support</span>
          </div>
        </div>
      </div>

      <div
        className="col col-24 lg-12 hero-1-image-container"
        data-aos="fade-left"
        data-aos-delay="200"
      >
        <div className="hero-1-floating-card hero-1-card-1">
          <span className="hero-1-card-icon">💻</span>
          <span className="hero-1-card-text">React Projects</span>
        </div>
        <div className="hero-1-floating-card hero-1-card-2">
          <span className="hero-1-card-icon">🚀</span>
          <span className="hero-1-card-text">Full Stack</span>
        </div>
        <div className="hero-1-floating-card hero-1-card-3">
          <span className="hero-1-card-icon">⚡</span>
          <span className="hero-1-card-text">Quick Setup</span>
        </div>

        <div className="hero-1-mockup">
          <div className="hero-1-code-window">
            <div className="hero-1-code-header">
              <span className="hero-1-dot"></span>
              <span className="hero-1-dot"></span>
              <span className="hero-1-dot"></span>
            </div>
            <div className="hero-1-code-content">
              <div className="hero-1-code-line">
                <span className="hero-1-code-keyword">import</span>
                <span className="hero-1-code-text"> React from 'react';</span>
              </div>
              <div className="hero-1-code-line">
                <span className="hero-1-code-keyword">const</span>
                <span className="hero-1-code-function"> App</span>
                <span className="hero-1-code-text"> = () =&gt; &#123;</span>
              </div>
              <div className="hero-1-code-line hero-1-code-indent">
                <span className="hero-1-code-keyword">return</span>
                <span className="hero-1-code-text">
                  {' '}
                  &lt;div&gt;Hello&lt;/div&gt;;
                </span>
              </div>
              <div className="hero-1-code-line">
                <span className="hero-1-code-text">&#125;;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection1;
